// Returns the API base URL.
//
// Why this exists:
// The production build hard-codes REACT_APP_BACKEND_URL at compile time. If
// that URL points to a different host than where the user actually visits
// (e.g. baked as `https://www.timberandthread.com.au` but the user is on the
// bare apex `https://timberandthread.com.au`), every fetch becomes a
// cross-origin request that triggers a CORS preflight — and if the configured
// host doesn't resolve in DNS, the preflight gets a 403 from the CDN and the
// browser shows "Failed to fetch".
//
// At runtime we know exactly which host the user is on (window.location.host).
// If the configured backend host only differs from the browser host by a
// `www.` prefix, snap the backend URL onto the browser host so the call is
// same-origin. No CORS preflight is fired and the call is guaranteed to reach
// the same backend that just served the HTML/JS.
const computeApiBase = () => {
  const raw = process.env.REACT_APP_BACKEND_URL || '';
  if (typeof window === 'undefined') return raw.replace(/\/$/, '');
  try {
    const configured = new URL(raw);
    const browserHost = window.location.host;
    if (configured.host !== browserHost) {
      const bareConfigured = configured.host.replace(/^www\./i, '');
      const bareBrowser = browserHost.replace(/^www\./i, '');
      if (bareConfigured === bareBrowser) {
        configured.host = browserHost;
      }
    }
    return configured.origin;
  } catch {
    return raw.replace(/\/$/, '');
  }
};

export const API = computeApiBase();
export default API;

// Normalize a backend-served URL to the CURRENT origin.
//
// Covers/media uploads are served at "/api/files/{id}". If a stored value has a
// hard-coded absolute origin (e.g. a cover saved as
// "https://t-and-t-refresh.preview.emergentagent.com/api/files/abc.jpg"), it
// would load from THAT host instead of the site the user is on — fragile and
// wrong in production. This strips the origin off any absolute "/api/files/..."
// URL so it resolves same-origin. Non-/api/files absolute URLs (e.g. the
// customer-assets CDN) are returned unchanged.
export const normalizeMediaUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  const m = url.match(/^https?:\/\/[^/]+(\/api\/files\/.+)$/i);
  return m ? m[1] : url;
};

